export default __webpack_public_path__ + "static/media/InductionHeatingImg.67bc68d8.jpg";